import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box } from '@mui/material';

const ERRORS = 'customPayments.fieldSettings.errors';
const VIOLATIONS = 'customPayments.fieldSettings.violations';

const FieldSettingsErrors = ({ errors = [] }) => {
  const { t } = useTranslation();

  if (errors.length === 0) return null;

  const toMessage = (error) => {
    if (error.scope === 'formProperties') {
      return t(`${ERRORS}.fixValidationSettings`);
    }

    const { key, ...interpolation } = error.violation;
    const violation = t(`${VIOLATIONS}.${key}`, interpolation);

    return error.scope === 'defaultValue'
      ? t(`${ERRORS}.defaultValue`, { violation })
      : t(`${ERRORS}.option`, {
          position: error.position,
          value: error.value,
          violation,
        });
  };

  const messages = errors.map((error, index) => ({
    id: `${error.scope}-${error.position ?? index}`,
    text: toMessage(error),
  }));

  return (
    <Alert
      severity='error'
      sx={{ mx: 3, mt: 2 }}
      data-testid='fieldSettingsConflictAlert'>
      {messages.length === 1 ? (
        messages[0].text
      ) : (
        <Box component='ul' sx={{ m: 0, pl: 2.5 }}>
          {messages.map((message) => (
            <li key={message.id}>{message.text}</li>
          ))}
        </Box>
      )}
    </Alert>
  );
};

export default FieldSettingsErrors;
